import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { OneClaim } from 'src/app/model/claim/OneClaim.model';
import { Step } from 'src/app/model/step.model';
import { TrackingTimelineResponse } from 'src/app/model/trackingTimelineResponse.model';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { ClaimService } from 'src/app/services/claim.service';
import { DeliveryChoiceService } from 'src/app/services/delivery-choice.service';
import { MappingServicesService } from 'src/app/services/mapping-services.service';
import { RechercheService } from 'src/app/services/recherche.service';
import { SpinnerService } from 'src/app/services/spinner.service';

declare let ATInternet;

@Component({
  selector: 'app-parcel-informations',
  templateUrl: './parcel-informations.component.html',
  styleUrls: ['./parcel-informations.component.scss']
})
export class ParcelInformationsComponent implements OnInit {

  parcelInformations: TrackingTimelineResponse = null;
  signingCode: string = '';
  parcelNumber: String;
  ipAddress: String;
  lastEventActive: Step;
  claimReference: string;
  securityCode: String;
  detailParcelSteps = [];
  otherReferences = [];
  alerts = [];
  panelOpenState = true;
  isClaimAuthorizedAF = false;
  isClaimAuthorizedCL = false;
  reasonAF = false;
  reasonCL = false;
  claimRefObs: Observable<OneClaim>;
  shortCode1;
  shortCode2;
  etapeSuiviColis;
  tag;
  toggleStyle: boolean;

  constructor(
    private activeRoute: ActivatedRoute,
    private rechercheService: RechercheService,
    private mappingService: MappingServicesService,
    private claimService: ClaimService,
    public spinnerService: SpinnerService,
    public deliveryChoiceService: DeliveryChoiceService,
    private atInternetService: AtInternetService) { 
    }

  ngOnInit(): void {
    
    // initialise parcel informations
    this.shortCode1 = this.activeRoute.snapshot.paramMap.get('securityCode1');
    this.shortCode2 = this.activeRoute.snapshot.paramMap.get('securityCode2');
    this.rechercheService.getTrackParcelByDoubleSecureCode(this.shortCode1, this.shortCode2, "fr_FR").subscribe(
      response => {
        this.detailParcelSteps = [];
        this.otherReferences = [];
        this.alerts = [];
        if (response.trackingTimelineResponse && response.trackingTimelineResponse.status[0].code === '0') {
          this.parcelInformations = response.trackingTimelineResponse;
          this.signingCode = response.confidentialCode;
          this.lastEventActive = this.getLastEventActive(this.parcelInformations);
          this.detailParcelSteps = this.mappingService.getDetailsSteps(this.parcelInformations, this.detailParcelSteps);
          this.otherReferences = this.mappingService.getOtherReferencesList(this.parcelInformations, this.otherReferences);
          this.alerts = this.mappingService.getAlerts(this.parcelInformations, this.alerts);
          if (this.parcelInformations.parcel && this.parcelInformations.parcel.parcelUuid) {
            this.getClaimInformationsAboutParcel(this.parcelInformations);
          }
        } else {
          window.open("https://www.laposte.fr/outils/suivre-vos-envois", "_self");
        }
      },
      err => {
        window.open("https://www.laposte.fr/outils/suivre-vos-envois", "_self");
      }
    );

    // si atinternet est prêt alors traquer, sinon pas traquer
    const serviceReadySubscription: Subscription = this.atInternetService.serviceReady$.subscribe((isReady: boolean) => {  
      if (isReady) {
          this.tag = new ATInternet.Tracker.Tag();
          if (this.parcelInformations && this.parcelInformations.parcel) {
            this.tag.setProps({
              page: 'page_de_suivi',
              numero_colis: this.parcelInformations.parcel.parcelNumber,
              compte_client_scgp: this.parcelInformations.parcel.contractNumber,
              etape_suivi_colis: this.switchPickupPoint(this.lastEventActive.stepId),
            }, false);
          }
          this.tag.page.set({
            name: 'page_de_suivi'
          });
          this.tag.dispatch();

          serviceReadySubscription.unsubscribe();
        } else {
          console.debug('xiti service not ready yet')
        }
    });

  }

  getClaimInformationsAboutParcel(parcelInformations) {
    this.claimService.getClaim(parcelInformations.parcel.parcelUuid).subscribe(
      response => {
        for (let claim of response.claimsMap) {
          if (claim.code === "AF") {
            this.reasonAF = true;
            this.claimReference = claim.ref;
            //Plus besoin de break dans cette condition car la Contestation Livraison (CL) doit toujours etre controle
          }
          if (claim.code === "CL") {
            this.reasonCL = true;
            this.claimReference = claim.ref;
            break;
          }
        }
        this.isClaimAuthorizedAF = this.checkClaimEligibilityForAF();
        this.isClaimAuthorizedCL = this.checkClaimEligibilityForCL();
      }
    );
  }

  getLastEventActive(parcelInformations): Step {
    var lastEvent = parcelInformations.parcel.step.reverse().find(oneStep => {
      if (oneStep.status === "STEP_STATUS_ACTIVE") return oneStep;
    })
    return lastEvent;
  }

  // RG001 RG002 RG003
  checkClaimEligibilityForAF(): boolean {
    var today = new Date();
    var limitDate = new Date();
    limitDate.setHours(17);
    limitDate.setMinutes(0);
    var seventeenToday = new Date(limitDate);

    return this.parcelInformations.parcel.deliveryMode === 'Domicile' && this.parcelInformations.parcel.geographicCoverage === 'NAT'
      && this.lastEventActive.stepId === 4 && (this.lastEventActive.subStepId === "DISIECIN" || this.lastEventActive.subStepId === "DISIECHEC" || this.lastEventActive.subStepId === "DISIPPREZ")
      && this.datesAreOnSameDay(today, new Date(this.lastEventActive.date)) && today < seventeenToday;
  }

  // RG001 RG004 RG005
  checkClaimEligibilityForCL(): boolean {
    let isLessThan2days = (this.lastEventActive.date && ((Date.now() < (new Date(this.lastEventActive.date).getTime() + 2 * 24 * 60 * 60 * 1000)))) ? true:false;
    return this.parcelInformations.parcel.codeTraffic != "8R" && this.parcelInformations.parcel.geographicCoverage === 'NAT'
      && this.lastEventActive.stepId === 5 && (this.lastEventActive.subStepId && ["DESLIEUD", "DESLIVD", "DESTIERS"].includes(this.lastEventActive.subStepId))
      && !this.parcelInformations.parcel.parcelBack && isLessThan2days;
  }

  datesAreOnSameDay(first, second) {
    return first.getFullYear() === second.getFullYear() &&
      first.getMonth() === second.getMonth() &&
      first.getDate() === second.getDate();
  }

  changeRefNumber = (refNumber): void => {
    this.claimReference = refNumber;
  }

  switchPickupPoint(stepId) {
    switch (stepId) {
      case 0: {
        this.etapeSuiviColis = "0_Expedition";
        return this.etapeSuiviColis;
      }
      case 1: {
        this.etapeSuiviColis = "1_Entree_dans_le_reseau";
        return this.etapeSuiviColis;
      }
      case 2: {
        this.etapeSuiviColis = "2_Acheminement";
        return this.etapeSuiviColis;
      }
      case 3: {
        this.etapeSuiviColis = "3_Site_de_livraison";
        return this.etapeSuiviColis;
      }
      case 4: {
        this.etapeSuiviColis = "4_Distribution";
        return this.etapeSuiviColis;
      }
      case 5: {
        this.etapeSuiviColis = "5_Destination";
        return this.etapeSuiviColis;
      }
      default: {
        break;
      }
    }
  }

  getDeliveryTitle() {
    if (this.parcelInformations.parcel.step[3].subStepId === "DISICHOIX"
      || this.parcelInformations.parcel.step[3].subStepId === "DISIHD"
      || this.parcelInformations.parcel.step[4].subStepId === "DISICHOIX"
      || this.parcelInformations.parcel.step[4].subStepId === "DISIHD") {
      return "deliveryChoice.modify_title"
    } else {
      return "deliveryChoice.absent"
    }
  }

  getDeliveryButtonTitle() {
    if (this.parcelInformations.parcel.step[3].subStepId === "DISICHOIX"
      || this.parcelInformations.parcel.step[3].subStepId === "DISIHD"
      || this.parcelInformations.parcel.step[4].subStepId === "DISICHOIX"
      || this.parcelInformations.parcel.step[4].subStepId === "DISIHD") {
      return "deliveryChoice.modify"
    } else {
      return "deliveryChoice.title"
    }
  }

  isMobile() {
    var width = window.outerWidth;
    if (width < 600 ) {
      return true;
    }
    return false;
  }
}
